import { includes } from "ramda";
import { paramPathSep, paramTermId } from "../constants/parameterNames";
import makeTaxonomyNamespaces from "../helpers/taxonomyNamespaces";

const optionalParameters = [
    {
        name: paramPathSep,
        description: "Indicate an optional path separator instead of the default semi-colon"
    }
];
const requiredParameters = [
    {
        name: paramTermId,
        description: "GUID for term Id"
    }
];
const description = "Queries SharePoint’s TaxonomyClientService to obtain the path for a given Term. Additional information on the metadata commands can be found on http://www.infopathdev.com/files/folders/qrules/entry76371.aspx.";

const SEMICOLON = ';';
const COLON = ':';

const findExistingSeparator = (path) => {
    if (includes(SEMICOLON, path)) {
        return SEMICOLON;
    }
    if (includes(COLON, path)) {
        return COLON;
    }

    return null;
};

const processTermPath = (parentPath, termPath, pathSep) => {
    if (!parentPath) {
        return termPath;
    }

    const existingPathSeparator = findExistingSeparator(parentPath);

    const fullTermPath = parentPath + pathSep + termPath;

    if (existingPathSeparator && existingPathSeparator !== pathSep) {
        // use requested separator if different from existing one
        return fullTermPath.replace(new RegExp(existingPathSeparator, 'g'), pathSep);
    }

    return fullTermPath;
};

function GetTermPath(params) {
    const cf = params.commonFunction;

    function executeAsync() {
        const namespaces = makeTaxonomyNamespaces();

        const termId = cf.getParamValue(paramTermId);
        const pathSep = cf.getParamValue(paramPathSep, ";");
        const domSource = cf.getDataSource("QdabraRules_TermSets");
        const termStoreBasePath = "/ns1:QdabraRulesTermSets/ns1:GetTermSets/tns:Container/tns:TermStore/tns:T[@a9='";
        const parentXpathSrc = termStoreBasePath + termId + "']/tns:TMS/tns:TM/@a40";
        const termXpathSrc = termStoreBasePath + termId + "']/tns:LS/tns:TL/@a32";
        const parentPath = domSource.selectSingle(parentXpathSrc, { namespaces }).value();
        const termPath = domSource.selectSingle(termXpathSrc, { namespaces }).value();

        return {
            result: processTermPath(parentPath, termPath, pathSep),
            success: true,
        };
    }

    return {
        description,
        executeAsync,
        optionalParameters,
        requiredParameters
    };
}

export default GetTermPath;